import React from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';

import HelpCenterTree from './HelpCenterTree';
import HelpCenterContactForm from './HelpCenterContactForm';

import './HelpCenterWidget.scss';

const HelpCenterWidget = () => {
    const { isOpen, view, isLauncherHidden, isExpanded } = useStoreState(state => state.helpCenter);
    const { openWidgetHome, closeWidget, setIsExpanded } = useStoreActions(actions => actions.helpCenter);

    return (
        <div id="help-center-widget">
            {isOpen &&
                <div className={`help-center-panel${isExpanded ? ' expanded' : ''}`}>
                    <div className="help-center-panel-actions">
                        <i
                            className={`fas ${isExpanded ? 'fa-compress' : 'fa-expand'} help-center-panel-resize`}
                            onClick={() => setIsExpanded(!isExpanded)}
                            aria-label={isExpanded ? 'Réduire' : 'Agrandir'}
                        />
                        <i className="fas fa-times help-center-panel-close" onClick={() => closeWidget()} />
                    </div>
                    <div className="help-center-panel-body">
                        {view === 'home' ? <HelpCenterTree /> : <HelpCenterContactForm />}
                    </div>
                </div>
            }

            {(isOpen || !isLauncherHidden) &&
                <button
                    type="button"
                    id="help-center-launcher"
                    onClick={() => (isOpen ? closeWidget() : openWidgetHome())}
                    aria-label="Aide"
                >
                    <span className="help-center-launcher-icon">
                        <i className={isOpen ? 'fas fa-times' : 'far fa-question-circle'} />
                    </span>
                    <span className="help-center-launcher-label">Aide</span>
                </button>
            }
        </div>
    );
};

export default HelpCenterWidget;
